import { MainContents } from '@/components/MainContents';
import { useNavigate } from '@tanstack/react-router';
import { showErrorToast } from '@/features/agent/job_change_processes/lib/toast';
import { JobPostImportRequestsUploadSection } from '../components/JobPostImportRequestsUploadSection';
import useCreateJobPostImportRequest from '../api/useCreateAndFetchJobPostImportRequest';

export function JobPostImportRequestsNewTemplate() {
  const { create, isPending } = useCreateJobPostImportRequest();
  const navigate = useNavigate();

  const handleFileSelected = async (file: File) => {
    try {
      const created = await create(file);
      navigate({
        to: '/agent/provided_job_posts/new/csv/$jobPostImportRequestId',
        params: { jobPostImportRequestId: created.encrypt_id },
      });
    } catch (error) {
      console.error(error);
      showErrorToast('CSVファイルのアップロードに失敗しました');
    }
  };

  return (
    <MainContents>
      <div className="grid grid-cols-1 gap-6">
        <section className="rounded-md bg-white p-6 shadow-xs">
          <JobPostImportRequestsUploadSection
            isPending={isPending}
            onFileSelected={handleFileSelected}
          />
        </section>
      </div>
    </MainContents>
  );
}
